<template>
  <div class="bg-white hpercent100">
    <div class="wpercent100 fixed margin-auto z-index2">
      <top-banner :msg="bankCardInfo"></top-banner>
        <!-- <div class="container pt-15 pb-15">
          <van-pagination v-model="currentPage" :total-items="total" force-ellipses @change="paginationChange" />
        </div> -->
    </div>
    <div class="container pt-160">
      <time-axis :list="list" v-show="list"></time-axis>
      <van-empty description="无交易记录" v-show="list.length === 0" />
    </div>
  </div>
</template>

<script>
import topBanner from './../../components/basic/TopBanner.vue';
import timeAxis from './../../components/basic/TimeAxis.vue';
import { getSessionStorage } from '@/utils/utils';
import { getStmBatchEmployeeList } from '@/api/project/index';
export default {
  components: { topBanner, timeAxis },
  created(){
    const obj = JSON.parse(getSessionStorage('employeeInfo'));
    this.bankCardInfo = `${obj.wageCardBank ? obj.wageCardBank : ``}${obj.wageCardNum ? `(${obj.wageCardNum})` : `无`}`
    this.getStmBatchEmployeeList();
  },
  data() {
    return {
      bankCardInfo: '',
      list:[],
      currentPage: 1,
      total: 0
    };
  },
  methods: {
    // 获取发薪记录列表
    async getStmBatchEmployeeList(pageNum, pageSize) {
      const obj = {
        projectId : getSessionStorage('projectId'),
        pageNum: pageNum ? pageNum : 1,
        pageSize: pageSize ? pageSize : 1000,
      }
      const { data } = await getStmBatchEmployeeList(obj);
      this.total = data.total; // 总条数
      this.list = this.sortData(data.list); // 反序赋值，因为需要新的在前面
      // this.list = data.list; // 不反序
    },
    // 分页
    paginationChange() {
      this.getStmBatchEmployeeList(this.currentPage);
    },
    // 写一个关于对象列表排序的功能 按照年月降序排列 返回一个新对象
    sortData(obj) {
      if(obj){
      let data = []; // 新对象用作对象push
      let sortdate = ''; // 新的push字段
      // 这里把组合字段年月转义为数字作为数字排序依据
      for(let i = 0; i < obj.length; i++){
        sortdate = Number(`${obj[i].year}` + `${obj[i].month}`);
        data.push({sortdate, ...obj[i]});
      }
      return data.sort((a, b) => b.sortdate - a.sortdate); // 返回 排序反序
      } else {
        return [];
      }
      
    }

  },
};
</script>

<style>
</style>